module.exports = __webpack_public_path__ + "img/m-switch-version.6b905bf4.png";